import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { defaultDelay, initialState } from './initialState';

export const messagesSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    show: (
      state,
      action: PayloadAction<{ message: string; delay?: number }>,
    ) => {
      state.message = action.payload.message;
      state.isOpen = true;
      state.delay = action.payload.delay ?? defaultDelay;
    },
    close: state => {
      state.message = '';
      state.isOpen = false;
    },
  },
});

export const { actions: messagesActions, reducer: messagesReducer } =
  messagesSlice;
